<!--
 * @description: 科普殿堂 内容列表
 * @Author: Jay
 * @Date: 2021-09-24 15:21:13
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 11:55:28
-->
<template>
  <div>
    <div class="palace-li" v-if="codeData != ''">
      <div
        class="code-li"
        v-for="(item, index) in codeData"
        :key="index"
        @click="skipDetails(item)"
      >
        <div v-class="'animate__animated animate__fadeInUp'">
          <el-image :src="$api + item.image" fit="fill" :lazy="true"></el-image>
          <!-- 标题 -->
          <div class="padding-xs">
            <p class="font_size_df text-black text-line">
              {{ item.name }}
            </p>
            <p class="font_size_sm text-gray margin-top-sm">
              <!-- {{ $operate.happenTime(item.createtime, "Y-M-D") }} -->
              {{ item.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容为空显示 -->
    <div v-else>
      <el-result icon="info" title="内容为空" subTitle="请联系管理员及时更新">
      </el-result>
    </div>
  </div>
</template>

<script>
export default {
  name: "PalaceListCode",
  props: ["codeData"],
  data() {
    return {};
  },
  methods: {
    //跳转详情
    skipDetails(item) {
      // console.log(item);
      //使用vuex 暂时缓存 数据
      this.$store.state.articleConter = item;
      //设置 临时 缓存
      // sessionStorage.setItem("article", item);
      //$router的两个API
      this.$router.push({
        path: "/PalaceDetails",
        // query: {
        //   id: xxx,
        //   title: xxx,
        // },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.palace-li {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto auto;
  grid-row-gap: 20px;
}
.code-li {
  width: 384px;
  //   background-color: aqua;
  .el-image {
    width: 100%;
    height: 220px;
  }
  .text-line {
    line-height: 20px;
    overflow: hidden;
  }
}

.code-li:hover {
  box-shadow: 1px 4px 20px 1px rgb(207, 207, 207);
}

// 只显示四行
.txt-clamp {
  line-height: 32px;
  display: -webkit-box;
  display: -moz-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
</style>
